module.exports = __webpack_public_path__ + "static/media/logo.7ea41626.png";